<template>
  <div class="privacy-txt">
    <span class="infoBox1">
      版本更新日期：2023 年 4 月 6 日
      <br />
      <br />
      版本生效日期：2023 年 4 月 6 日
      <br />
      <br />
      引言
      <br />
      <br />
      深圳优制云工业互联网有限公司旗下的伟班是（包括伟班官方网站（域名为www.veiban.com）及伟班APP客户端，伟班PC客户端、伟班后台管理系统，下称“我们”或“伟班”）非常尊重用户个人信息的保护。本隐私权政策包含了我们收集、存储、使用、共享和保护您的个人信息的条款，我们希望通过本隐私权政策向您清晰地介绍我们对您个人信息的处理方式，因此我们建议您完整地阅读本隐私权政策，以帮助您了解维护自己隐私权的方式。如您对本隐私权政策有任何疑问，您可以通过伟班公布的联系方式与我们联系。如果您不同意本隐私权政策任何内容，您应立即停止使用伟班服务。当您使用伟班提供的任一服务时，即表示您已同意我们按照本隐私权政策来合法使用和保护您的个人信息。
      <br />
      <br />
      一、适用范围
      <br />
      <br />
      (a)在您注册本应用app帐号时，您根据app要求提供的个人注册信息。
      <br />
      <br />
      (b)在您使用本应用网络服务，或访问本应用平台网页时，本应用自动接收并记录的您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据。
      <br />
      <br />
      (c)本应用通过合法途径从商业伙伴处取得的用户个人数据。
      <br />
      <br />
      (d)本应用严禁用户发布不良信息，如裸露、色情和亵渎内容，发布的内容我们会进行审核，一经发现不良信息，会禁用该用户的所有权限，予以封号处理。
      <br />
      <br />
      二、信息使用
      <br />
      <br />
      (a)本应用不会向任何无关第三方提供、出售、出租、分享或交易您的个人登录信息。如果我们存储发生维修或升级，我们会事先发出推送消息来通知您，请您提前允许本应用消息通知。
      <br />
      <br />
      (b)本应用亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何本应用平台用户如从事上述活动，一经发现，本应用有权立即终止与该用户的服务协议。
      <br />
      <br />
      三、信息披露
      <br />
      <br />
      在如下情况下，本应用将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：
      <br />
      <br />
      (a)未经您事先同意，我们不会向第三方披露。
      <br />
      <br />
      (b)为提供您所要求的产品和服务，而必须和第三方分享您的个人信息。
      <br />
      <br />
      (c)根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露。
      <br />
      <br />
      (d)如您出现违反中国有关法律、法规或者本应用服务协议或相关规则的情况，需要向第三方披露。
      <br />
      <br />
      (e)如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷。
      <br />
      <br />
      四、我们如何共享信息
      <br />
      <br />
      我们对您的信息承担保密义务，不会为满足第三方的营销目的而向其出售或出租您的任何信息，我们会在下列情况下才将您的信息与第三方共享：
      <br />
      <br />
      1.事先获得您的同意或授权。
      <br />
      <br />
      2.根据法律法规的规定或行政或司法机构的要求。
      <br />
      <br />
      3.向伟班的关联方分享您的个人信息。
      <br />
      <br />
      4.向可信赖的合作伙伴提供您的个人信息，让他们根据我们的指示并遵循我们的隐私权政策以及其他任何相应的保密和安全措施来为我们处理这些信息。
      <br />
      <br />
      5.如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷。
      <br />
      <br />
      6.只有共享您的信息，才能提供您需要的服务，或处理您与他人的纠纷或争议。例如您在伟班上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，伟班会视情况向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。
      <br />
      <br />
      7.如您出现违反中国有关法律、法规或者伟班相关协议或相关规则的情况，需要向第三方披露。
      <br />
      <br />
      8.为维护伟班及其关联方或用户的合法权益。
      <br />
      <br />
      五、Cookie 和网络 Beacon 的使用
      <br />
      <br />
      为使您获得更轻松的访问体验，您访问伟班相关网站或使用伟班提供的服务时，我们可能会通过小型数据文件识别您的身份，这么做是帮您省去重复输入注册信息的步骤，或者帮助判断您的账户安全。这些数据文件可能是Cookie，Flash
      Cookie，或您的浏览器或关联应用程序提供的其他本地存储（统称“Cookie”）。
      <br />
      <br />
      请您理解，我们的某些服务只能通过使用“Cookie”才可得到实现。如果您的浏览器或浏览器附加服务允许，您可以修改对Cookie的接受程度或者拒绝伟班的Cookie，但这一举动在某些情况下可能会影响您安全访问伟班相关网站和使用伟班提供的服务。
      <br />
      <br />
      网页上常会包含一些电子图象（称为"单像素" GIF 文件或 "网络
      beacon"），使用网络beacon可以帮助网站计算浏览网页的用户或访问某些cookie，我们会通过网络beacon收集您浏览网页活动的信息，例如您访问的页面地址、您先前访问的援引页面的位址、您停留在页面的时间、您的浏览环境以及显示设定等。
      <br />
      <br />
      六、信息存储
      <br />
      <br />
      伟班收集的有关您的信息和资料将保存在伟班及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或伟班收集信息和资料所在地并在该地被访问、存储和展示。
      <br />
      <br />
      七、您的个人信息保护
      <br />
      <br />
      为保障您的信息安全，我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的信息，使您的信息不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。我们对可能接触到您的信息的员工或外包人员也采取了严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们签署保密协议，监控他们的操作情况等措施。伟班会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，伟班将尽力做到使您的信息不被泄漏、毁损或丢失。
      <br />
      <br />
      您的账户均有安全保护功能，请妥善保管您的账户及密码信息。伟班将通过向其它服务器备份、对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您理解在信息网络上不存在“完善的安全措施”。
      <br />
      <br />
      在使用伟班服务进行网上交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是你的账户及密码发生泄露，请您立即联络伟班客服，以便伟班采取相应措施。
      <br />
      <br />
      八、用户信息主体注销账户
      <br />
      <br />
      您随时可注销此前注册的账户，您可以通过以下方式自行操作：我的 > 账号安全 > 注销账号。
      <br />
      <br />
      在注销账户之后，我们将停止为您提供产品或服务并依据您的要求，删除或匿名化您的信息，法律法规另有规定的除外。这也将可能导致您失去对您账户中数据的访问权，请您谨慎操作。
      <br />
      <br />
      九、未成年人保护
      <br />
      <br />
      我们重视未成年人的个人信息保护，如您为未成年人，建议您请您的监护人仔细阅读本隐私权政策，并在征得您的监护人同意的前提下使用我们的服务或向我们提供信息。
      <br />
      <br />
      十、隐私保护政策的修改
      <br />
      <br />
      伟班有权随时修改《隐私保护政策》的任何条款，一旦《隐私保护政策》的内容发生变动，伟班将会直接在伟班网站及移动客户端上公布修改之后的《隐私保护政策》，该公布行为视为伟班已经通知您修改内容。伟班也可通过其他适当方式向用户提示修改内容。如果您不同意伟班对本《隐私保护政策》相关条款所做的修改，您有权停止使用伟班服务。如果您继续使用伟班服务，则视为您接受深圳优制云工业互联网有限公司对本协议相关条款所做的修改。
      <br />
      <br />
      十一、如何联系我们
      <br />
      <br />
      （一）如您对本隐私政策或您个人信息的相关事宜有任何问题、意见或建议，请联系伟班客服进行反馈；
      <br />
      <br />
      联系地址：广东省深圳市瀚南山区朗山路16号华瀚创新园A座9楼
      <br />
      <br />
      开发者名称：深圳优制云工业互联网有限公司
      <br />
      <br />
      您还可以随时通过访问在线客服系统或拨打我们的任何一部客服电话等多种方式与我们联系。
      <br />
      <br />
      十二、Android系统应用权限列表：
      <br />
      <br />
      1.权限名称：存储读写权限
      <br />
      <br />
      权限代码：
      <br />
      <br />
      READ_EXTERNAL_STORAGE
      <br />
      <br />
      WRITE_EXTERNAL_STORAGE
      <br />
      <br />
      权限功能说明：允许程序读写数据到程序外的存储。
      <br />
      <br />
      使用场景和目的：外勤打卡时可能需要上传照片文件、审批流程时需要上传附件、公告或审批中需要预览附件等。
      <br />
      <br />
      2.权限名称：相机权限
      <br />
      <br />
      权限代码：
      <br />
      <br />
      CAMERA
      <br />
      <br />
      权限功能说明：允许程序使用拍照功能。
      <br />
      <br />
      使用场景：打卡时可能需要拍照，修改头像可能需要拍照，上传附件可能需要拍照，视频会议访问相机等。
      <br />
      <br />
      3.权限名称：定位权限
      <br />
      <br />
      权限代码：
      <br />
      <br />
      ACCESS_FINE_LOCATION
      <br />
      <br />
      ACCESS_COARSE_LOCATION
      <br />
      <br />
      权限功能说明：获取GPS、Wi-Fi、基站位置信息。
      <br />
      <br />
      使用场景：考勤时需要获取地理位置。
      <br />
      <br />
      4.名称：收集软件安装列表、手机号、AndroidID、MAC等数据
      <br />
      <br />
      说明：第三方SDK如极光消息推送、腾讯Bugly等所获取的权限
      <br />
      <br />
      使用场景：仅限第三方SDK为统计数据，实现本身的特定功能等需要，不作为伟班数据保留，也不会进行广告推荐等，详细请参照第三方服务协议
      <br />
      <br />
      5.名称：录音和蓝牙权限
      <br />
      <br />
      权限代码：
      <br />
      <br />
      RECORD_AUDIO
      <br />
      <br />
      BLUETOOTH_CONNECT
      <br />
      <br />
      说明：第三方SDK网易云信音视频通话2.0所获取的权限
      <br />
      <br />
      使用场景：视频会议中进行语音和视频通话需要。
      <br />
      <br />
      6.名称：位置定位、轨迹记录功能
      <br />
      <br />
      伟班产品与/或服务为您提供位置定位和轨迹记录服务，在此过程中，我们需要收集您的地理位置，包括如下个人信息：位置信息、行踪轨迹。同时为了收集上述基本的个人位置信息，我们将会申请您的位置权限，
      我们收集这些信息是为了向您提供位置定位和轨迹记录服务，如您拒绝提供上述权限将可能导致您无法使用我们的位置定位和轨迹记录服务。
      <br />
      <br />
      需要说明的是，位置权限是您设备上的一项设置，您可以通过设备设置页面进行管理。但除非您依照法律的规定请求删除了您的个人信息，
      否则您在设备上的权限取消行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。
      <br />
      <br />
      7.基于伟班产品提供服务自启动和关联启动的功能
      <br />
      <br />
      当您登录伟班并使用定位轨迹（工作线路）功能时，我们将需要软件在后台自启动或关联启动，或通过安卓/IOS系统发送广播唤醒APP自启动或关联启动，以保证定位轨迹（工作线路）功能正常使用，能形成完整的路线。
      如您拒绝提供的仅会使您无法使用该功能，但并不影响您正常使用产品与/或服务的其他功能。自启动权限是您设备上的一项设置，您可以通过设备设置页面进行管理。但除非您依照法律的规定删除了您的个人信息，
      否则您的取消行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。
      <br />
      <br />
      8.基于伟班产品提供服务获取设备MAC地址权限
      <br />
      <br />
      当您登录伟班时，我们将需要获取您的设备MAC地址的权限，识别登录设备是否变化，用于实现软件内绑定手机的功能以及更换登录设备的识别功能。如您拒绝提供的仅会使您无法使用该功能，
      但并不影响您正常使用产品与/或服务的其他功能。MAC地址获取权限是您设备上的一项设置，您可以通过设备设置页面进行管理。但除非您依照法律的规定删除了您的个人信息，
      否则您的取消行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。
      <br />
      <br />
      9.基于伟班产品提供读取应用列表的业务功能
      <br />
      <br />
      当您登录伟班时，我们将需要获取读取应用列表的权限，识别手机内是否有安装可以更改定位、破坏我们软件定位真实性的app，用于实现保证定位真实的功能、杜绝用户修改真实定位地址。
      如您拒绝提供的仅会使您无法使用该功能，但并不影响您正常使用产品与/或服务的其他功能。应用列表获取权限是您设备上的一项设置，您可以通过设备设置页面进行管理。
      但除非您依照法律的规定删除了您的个人信息，否则您的取消行为不会影响我们基于您之前的授权进行的个人信息的处理、存储。
      <br />
      <br />
      十二、Android第三方SDK列表：
      <br />
      <br />
      1.极光及小米，OPPO，华为，vivo等消息推送
      <br />
      <br />
      SDK服务协议链接：https://docs.jiguang.cn/compliance_guide/app_compliance_guide/app_compliance_guide1/
      <br />
      https://docs.jiguang.cn/jpush/client/jghgzy_a_i_h
      <br />
      <br />
      华为隐私政策协议：https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177
      <br />
      <br />
      vivo隐私政策协议：https://dev.vivo.com.cn/documentCenter/doc/652
      <br />
      <br />
      小米隐私政策协议： https://privacy.mi.com/all/zh_CN/
      <br />
      <br />
      oppo隐私政策协议： https://open.oppomobile.com/new/developmentDoc/info?id=10288
      <br />
      <br />
      设备权限：设备信息、地理位置、网络信息、收集软件安装列表、手机号、MAC、设备标识OAID、Android ID、应用包名、版本号和运行状态等个人信息。
      <br />
      <br />
      使用场景：系统消息推送。
      <br />
      <br />
      2.百度定位
      <br />
      <br />
      SDK服务协议链接：https://lbsyun.baidu.com/index.php?title=open/law
      <br />
      <br />
      设备权限：访问Wi-Fi状态
      <br />
      <br />
      使用场景：获取连接WIFI信息，返回至百度定位服务端作为辅助定位依据，再返回给开发者更精准的位置信息。
      <br />
      <br />
      设备权限：位置信息
      <br />
      <br />
      使用场景：获取连接WI-FI信息，返回至百度定位服务端作为辅助定位依据，再返回给开发者更精准的位置信息。
      <br />
      <br />
      3.腾讯Bugly统计
      <br />
      <br />
      SDK服务协议链接：https://static.bugly.qq.com/bugly-sdk-privacy-statement.pdf
      <br />
      <br />
      收集信息：日志信息（包括：第三方开发者自定义日志、Logcat 日志以及 APP 崩溃堆栈信息）、设备 ID（包括：androidid 以及idfv）、软件安装列表、手机号、联网信息、系统名称、系统版本以及国家码。
      <br />
      <br />
      使用场景：实现各类 Bugly SDK 的特定业务功能。
      <br />
      <br />
      4.腾讯X5内核
      <br />
      <br />
      SDK说明：https://x5.tencent.com/docs/questions.html
      <br />
      <br />
      收集信息：国际设备识别码（IMEI）、国际移动用户识别码（IMSI）、网卡地址（MAC
      Address）、软件安装列表、手机号、用户机型、屏幕尺寸、操作系统版本号、目标API（targetAPI）、网络类型(ApnType)、网络变化监听广播以及 Wifi的mac地址。
      <br />
      <br />
      使用场景：实现各类腾讯浏览服务SDK的特定业务功能。
      <br />
      <br />
      5.网易云信-音视频通话2.0
      <br />
      <br />
      SDK服务协议链接：https://yunxin.163.com/clauses?serviceType=0
      <br />
      <br />
      SDK隐私政策链接：https://yunxin.163.com/clauses?serviceType=3
      <br />
      <br />
      设备权限：录音、蓝牙
      <br />
      <br />
      使用场景：仅用于视频会议中语音和视频通话的功能支持
      <br />
      <br />
      注：本隐私政策版本更新日期为 2023 年 4 月 6 日，将于 2023 年 4 月 6 日正式生效。
      <br />
      <br />
      <br />
    </span>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.privacy-txt {
  width: 100vw;
  font-size: 16px;
  padding: 0.2rem;
}
.infoBox1 {
  overflow-wrap: break-word;
  color: rgba(102, 102, 102, 1);
  font-size: 16px;
  font-family: PingFangSC-Regular;
  line-height: 17px;
  text-align: justify;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
